import { Visibility } from '@mui/icons-material';
import { ThemeProvider } from '@mui/material/styles';
import { DicomViewer, getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { mounted, unmounted } from 'FRONTEND/reducers/sidePanelSlice';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';
import { setupDWVWorkerResolver } from 'FRONTEND/utils/dwvWorkerResolver';


export default (element, store) => {
  // Initialize DWV worker path resolver (singleton that will only run once globally, when a component instance mounts)
  setupDWVWorkerResolver();

  store.dispatch(mounted());

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  const customPreviewButton = (props) => (
    // Match jinja styles
    <span className='btn' {...props} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <Visibility />
    </span>
  );

  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <DicomViewer
            file={element.dataset.file}
            title={element.dataset.title}
            description={element.dataset.description}
            CustomPreviewButton={customPreviewButton}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    store.dispatch(unmounted());
    root.unmount();
  };
};
